'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'treasure-chest';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f723';
var svgPathData = 'M80 41.3l0 206.7-80 0 0-88C0 106.3 33.1 60.3 80 41.3zM0 296l80 0 0 184-16 0c-35.3 0-64-28.7-64-64L0 296zM128 480l0-184 96 0 0 24c0 17.7 14.3 32 32 32s32-14.3 32-32l0-24 96 0 0 184-256 0zm304 0l0-184 80 0 0 120c0 35.3-28.7 64-64 64l-16 0zm80-232l-80 0 0-206.7c46.9 19 80 65 80 118.7l0 88zM384 32l0 216-96 0 0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24-96 0 0-216 256 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTreasureChest = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;